//
//  components/wayhood/WayhoodOfficialShell.tsx
//  TownLIT
//
//  Created by Hossein Sakkaki on 2026-10-19.
//  Last Update by Hossein Sakkaki on 2026-10-19.
//

"use client";

import { useEffect, type ReactNode } from "react";
import { useDispatch } from "react-redux";

import TownlitOfficialLayout from "../layouts/TownlitOfficialLayout";
import { getTermsAndPolicies } from "../../redux/main/mainSlice";
import type { AppDispatch } from "../../redux/storeTypes";

export default function WayhoodOfficialShell({
  children,
}: {
  children: ReactNode;
}) {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    // Load official footer policies for standalone public pages.
    void dispatch(getTermsAndPolicies());
  }, [dispatch]);

  return (
    <div className="townlit-root-container wayhood-root-container">
      <div className="scroll-wrapper wayhood-scroll-wrapper">
        <TownlitOfficialLayout headerType="alternate">
          {children}
        </TownlitOfficialLayout>
      </div>
    </div>
  );
}
